module.exports = __webpack_public_path__ + "img/unionPayDownload2.6473a136.png";